module.exports = __webpack_public_path__ + "static/media/thumbs_lagodigital_4.9c6e6b30.jpg";